
export enum StoreEnum {
  'TOKEN' = 'TOKEN',
  'LOGIN' = 'LOGIN'
}
